import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { Toaster } from 'sonner'
import { Spinner } from '@/components/ui/primitives'
import { PageShell, StateMessage } from '@/components/Layout'
import { EventConfigProvider } from '@/hooks/useEvent'
import HomePage from '@/pages/Home'

/**
 * Only the landing page is in the entry bundle.
 *
 * Most people who open the link look at the shirt and leave, so the five-step form
 * (react-hook-form, zod, four Radix packages), the QR renderer and the whole admin
 * console are all separate chunks fetched on the route that needs them. The cost of
 * arriving is the cost of the page you arrived at.
 */
const OrderPage = lazy(() => import('@/pages/Order'))
const ResultPage = lazy(() => import('@/pages/Result'))
const CheckPage = lazy(() => import('@/pages/Check'))
const AdminApp = lazy(() => import('@/pages/admin/AdminApp'))

const Loading = () => (
  <div className="grid min-h-dvh place-items-center">
    <Spinner />
  </div>
)

export const App = () => (
  <>
    <EventConfigProvider>
    <Suspense fallback={<Loading />}>
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/order" element={<OrderPage />} />
      <Route path="/result" element={<ResultPage />} />
      <Route path="/check" element={<CheckPage />} />
      <Route path="/admin/*" element={<AdminApp />} />
      <Route
        path="/404"
        element={
          <PageShell title="ไม่พบหน้านี้">
            <StateMessage tone="warning" title="ไม่พบหน้าที่ต้องการ" detail="ลิงก์อาจหมดอายุหรือพิมพ์ไม่ถูก" />
          </PageShell>
        }
      />
      <Route path="*" element={<Navigate to="/404" replace />} />
    </Routes>
    </Suspense>
    </EventConfigProvider>
    {/*
      * sonner ships its own font stack, which on a Thai page means the toast is the
      * one piece of text in a different typeface — and Thai in a fallback font sets
      * its vowel marks badly enough to notice. `font-sans` hands it the page's font.
      */}
    <Toaster
      position="top-center"
      richColors
      closeButton
      className="font-sans"
      toastOptions={{ className: 'font-sans text-[15px]' }}
    />
  </>
)

export default App
